import React from 'react';

import { Landing } from '../../components/Landing/Landing';

export const LandingView: React.FC = () => {
  return <Landing />;
};
